import React, {useEffect, useState, useRef, useMemo} from "react";
import { Button, FormGroup, ControlLabel, FormControl, Glyphicon } from "react-bootstrap";
import {getStreamPublishParameters} from "../../../../../../common/src/MediaServer";

export default ({ stream, liveProfiles }) => {
    const timeout = useRef(null);
    const [copied, setCopied] = useState(null);

    useEffect(() => {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }

        if (copied) {
            timeout.current = setTimeout(() => setCopied(null), 1000);
        }

        return () => clearTimeout(timeout.current);
    }, [copied]);

    const liveProfile = useMemo(() => liveProfiles.find(({ id }) => id === stream.liveProfileId), [liveProfiles, stream.liveProfileId]);
    const {url: publishUrl, name: publishStreamName} = useMemo(
        () => getStreamPublishParameters(liveProfile, stream.name, stream.authKey, stream.useTranscoder),
        [liveProfile, stream.name, stream.authKey, stream.useTranscoder]
    );

    const copyValues = [
        {
            id: 'fmsUrl',
            title: 'FMS URL',
            value: publishUrl,
        },
        {
            id: 'streamName',
            title: 'StreamName',
            value: publishStreamName,
        },
    ];

    return <div style={{ marginTop: '1rem' }}>
        {!stream.liveProfileId && <div style={{ color: 'red', padding: '0.5rem 0' }}>Профиль CDN Live не выбран. Вещание невозможно!</div>}
        {copyValues.map(({ id, title, value }) => (
            <FormGroup key={id}>
                <ControlLabel>{title}</ControlLabel>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <FormControl
                        type="text"
                        value={value}
                        readOnly
                    />
                    <Button onClick={() => {
                        navigator.clipboard.writeText(value);
                        setCopied(id);
                    }}>{id === copied ? <Glyphicon glyph="ok" /> : 'Copy'}</Button>
                </div>
            </FormGroup>
        ))}
    </div>
}
